import { Button, Card, Input, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { Accordion, Icon, Label } from "semantic-ui-react";
import ModalAddDocument from "./ModalAddDocument";
import { db } from "../database/firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { renderClassName } from "../utils";
import ModalTransfer from "./ModalTransfer";
import {
  getDataDoc,
  downloadFolderAsZip,
  updateDocDatabase,
  deleteDataDoc,
} from "../database";
import { useSelector } from "react-redux";
import { openErrorNotification } from "./Notifications/errorNotification";
import { openSuccesNotification } from "./Notifications/succesNotification";
import Clase from "../Pages/Admin/Clase";
import withErrorBoundary from "./withErrorComponent";
const { TextArea } = Input;
const formatDate = (today) => {
  const romaniaTime = new Date(
    today.toLocaleString("en-US", { timeZone: "Europe/Bucharest" })
  );

  const yyyy = romaniaTime.getFullYear();
  let mm = romaniaTime.getMonth() + 1; // Months start at 0!
  let dd = romaniaTime.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  return dd + "/" + mm;
};

const Docs = ({
  elevId,
  numeElev,
  classId,
  retras = false,
  modeOf = "edit",
  openAll = undefined,
  elevData,
  transferuri = false,
}) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [open, setOpen] = useState(false);
  const user = useSelector((state) => state.user);
  const [editTransfer, setEditTransfer] = useState(false);
  const [idTransfer, setIdTransfer] = useState("");
  const [promiss, setPromiss] = useState("");
  const [clasaVeche, setClasaVeche] = useState("");
  const [mode, setMode] = useState(null);
  const [docsElev, setDocsElev] = useState([]);
  const [motivariManuale, setMotivariManuale] = useState([]);
  const clase = useSelector((state) => state.clase);
  const materii = useSelector((state) => state.materii);
  const handleClick = (e, titleProps) => {
    const { index } = titleProps;

    const newIndex = activeIndex === index ? -1 : index;

    setActiveIndex(newIndex);
  };

  const fetch = async () => {
    try {
      const data = await getDataDoc("eleviDocumente", elevId);
      setDocsElev(data?.docsElev);

      // Fetch motivări manuale
      const notesData = await getDataDoc("catalog", elevId);
      if (notesData?.note) {
        const motivariManualeFiltered = notesData.note.filter(
          n => n.tip === "absenta" && n.motivareManual === true
        );
        setMotivariManuale(motivariManualeFiltered);
      }
    } catch (err) {
      openErrorNotification(err.message);
    }
  };
  useEffect(() => {
    if (!elevId) return;

    const unsub = onSnapshot(doc(db, "eleviDocumente", elevId), (doc) => {
      const source = doc.metadata.hasPendingWrites ? "Local" : "Server";
      setDocsElev(doc.data()?.docsElev);
    });

    // Listener pentru motivări manuale din catalog
    const unsub2 = onSnapshot(doc(db, "catalog", elevId), (doc) => {
      const notesData = doc.data();
      if (notesData?.note) {
        const motivariManualeFiltered = notesData.note.filter(
          n => n.tip === "absenta" && n.motivareManual === true
        );
        setMotivariManuale(motivariManualeFiltered);
      }
    });

    return () => {
      unsub();
      unsub2();
    };
  }, [elevId]);
  useEffect(() => {
    if (!elevId) return;
    fetch();
  }, [elevId]);

  return (
    <div>
      <ModalTransfer
        open={editTransfer}
        setOpen={setEditTransfer}
        id={elevId}
        idTransfer={idTransfer}
        elevData={elevData}
        promiss={promiss}
        clasaVeche={clasaVeche}
      />

      {retras !== true && modeOf !== "view" && transferuri === false && (
        <Button
          type="primary"
          style={{ width: "100%" }}
          onClick={() => {
            setOpen(true);
          }}
        >
          Adaugă Document
        </Button>
      )}
      {modeOf !== "view" && transferuri === false && (
        <ModalAddDocument
          open={open}
          setOpen={setOpen}
          elevId={elevId}
          docsElev={docsElev}
          setDocsElev={setDocsElev}
          mode={mode}
          classId={classId}
          setMode={setMode}
          numeElev={numeElev}
        />
      )}
      {transferuri === false && (
        <Accordion fluid styled>
          {docsElev
            ?.sort((a, b) => {
              const statusOrder = {
                waiting: 0,
                denied: 2,
                accepted: 2,
                undefined: 3,
              };

              if (
                statusOrder[a.verified || "undefined"] ===
                statusOrder[b.verified || "undefined"]
              ) {
                return b.id - a.id;
              }

              return (
                statusOrder[a.verified || "undefined"] -
                statusOrder[b.verified || "undefined"]
              );
            })
            .filter((doc) => doc.verified === "accepted" || mode !== "view")
            ?.map((doc, index) => {
              return (
                <div style={{ pageBreakInside: "avoid" }}>
                  <Accordion.Title
                    active={activeIndex === index}
                    index={index}
                    onClick={handleClick}
                  >
                    {" "}
                    <Icon name="dropdown" />
                    {doc.nume}
                    {" - "}{" "}
                    {doc.subType === "profesor" ? "Motivare profesor" : doc.tip}
                    {doc.tip === "scutire" || doc.tip === "bilet"
                      ? " #" +
                        doc?.ranges?.map(
                          (range) =>
                            " " +
                            formatDate(new Date(range.start)) +
                            " - " +
                            formatDate(new Date(range.end))
                        )
                      : " #" + formatDate(new Date(doc.uploaded))}
                    &nbsp; &nbsp; &nbsp;
                    {doc.verified === "waiting" && (
                      <Tag color="yellow">Scutire în curs de validare</Tag>
                    )}
                    {doc.verified === "accepted" && (
                      <Tag color="green"> Validat</Tag>
                    )}
                    {doc.verified === "denied" && (
                      <Tag color="red"> Scutire Respinsă - {doc.motiv}</Tag>
                    )}
                  </Accordion.Title>

                  <Accordion.Content active={openAll || activeIndex === index}>
                    {" "}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                      }}
                    >
                      <div>
                        Nume &nbsp;
                        {doc.nume}
                      </div>
                      <div>
                        Tip &nbsp;
                        {doc.subType === "profesor"
                          ? "Motivare profesor"
                          : doc.tip === "scutire"
                          ? "Scutire medicala/oficiala"
                          : doc.tip === "bilet"
                          ? "Bilet de voie"
                          : doc.tip}
                      </div>
                      {(doc.tip === "scutire" || doc.tip === "bilet") && (
                        <div>
                          Interval: &nbsp;
                          {doc?.ranges?.map(
                            (range) =>
                              formatDate(new Date(range.start)) +
                              " - " +
                              formatDate(new Date(range.end)) +
                              "; "
                          )}
                        </div>
                      )}

                      <div>
                        Incarcat in &nbsp;
                        {formatDate(new Date(doc.uploaded))}
                      </div>
                    </div>
                    <br />
                    <TextArea
                      value={doc.details}
                      style={{ width: "50%", outline: "none" }}
                    />
                    <br />
                    <br />
                    {doc.download && (
                      <Button
                        type="primary"
                        onClick={() => {
                          downloadFolderAsZip(
                            "documente" + doc.id + "_" + doc.uploaded,
                            numeElev + "_document" + doc.nume
                          );
                        }}
                      >
                        Descarca Documente
                      </Button>
                    )}
                    <br />
                    <br />
                    {modeOf !== "view" && (
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          margin: "auto",
                          justifyContent: "center",
                        }}
                      >
                        {user.type === "admin" && (
                          <Button
                            danger
                            style={{ width: "25%" }}
                            onClick={async () => {
                              await updateDocDatabase(
                                "eleviDocumente",
                                elevId,
                                {
                                  docsElev: docsElev.filter(
                                    (d) => d.id !== doc.id
                                  ),
                                }
                              ).then(() => {
                                openSuccesNotification("Ai sters documentul");
                              });
                              let now = new Date();
                              let onejan = new Date(now.getFullYear(), 0, 1);
                              let week = Math.ceil(
                                ((now.getTime() - onejan.getTime()) / 86400000 +
                                  onejan.getDay() +
                                  1) /
                                  7
                              );

                              let changelogGet = await getDataDoc(
                                "changelog",
                                classId + "week" + week
                              );
                              let previous = [];
                              if (changelogGet) previous = changelogGet;
                              await updateDocDatabase(
                                "changelog",
                                classId + "week" + week,
                                {
                                  changelog: [
                                    ...(previous.changelog || []),
                                    {
                                      author: user.displayName,
                                      time: Date.now(),
                                      classId,
                                      elevId,
                                      sterge: true,
                                      scutire: doc,
                                    },
                                  ],
                                }
                              );
                            }}
                          >
                            Sterge
                          </Button>
                        )}

                        <Button
                          type="dashed"
                          style={{ width: "25%" }}
                          onClick={() => {
                            setMode({
                              type: "edit",
                              values: {
                                nume: doc.nume,
                                tip: doc.tip,
                                details: doc.details,
                                ranges: doc.ranges,
                                uploaded: doc.uploaded,
                                lastId: doc.id,
                                tip_scutire: doc.tip_scutire,
                                id: doc.id,
                              },
                            });
                            setOpen(true);
                          }}
                        >
                          Edit
                        </Button>
                      </div>
                    )}
                  </Accordion.Content>
                </div>
              );
            })}
        </Accordion>
      )}

      {/* Secțiunea pentru Motivări Manuale */}
      {motivariManuale && motivariManuale.length > 0 && (
        <>
          <h3 style={{ textAlign: "center", marginTop: "20px" }}>
            Motivări Manuale
          </h3>
          <Accordion fluid styled>
            {motivariManuale
              .sort((a, b) => (b.dataMotivare || 0) - (a.dataMotivare || 0))
              .map((motivare, index) => {
                const materieNume = materii?.find(m => m.id === motivare.materieId)?.numeMaterie || "Materie necunoscută";

                return (
                  <div key={motivare.id} style={{ pageBreakInside: "avoid" }}>
                    <Accordion.Title
                      active={activeIndex === `motivare-${index}`}
                      index={`motivare-${index}`}
                      onClick={handleClick}
                    >
                      <Icon name="dropdown" />
                      Absență motivată manual - {" "}
                      {motivare.date && new Date(motivare.date).toLocaleDateString("ro-RO")}
                      {" - "}
                      {materieNume}
                      &nbsp; &nbsp;
                      <Tag color="green">Motivat Manual</Tag>
                    </Accordion.Title>

                    <Accordion.Content
                      active={openAll || activeIndex === `motivare-${index}`}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                          marginBottom: "15px"
                        }}
                      >
                        <div>
                          <strong>Data absenței:</strong>&nbsp;
                          {motivare.date && new Date(motivare.date).toLocaleDateString("ro-RO")}
                        </div>

                        <div>
                          <strong>Materie:</strong>&nbsp;
                          {materieNume}
                        </div>

                        <div>
                          <strong>Data motivării:</strong>&nbsp;
                          {motivare.dataMotivare &&
                            new Date(motivare.dataMotivare).toLocaleDateString("ro-RO")}
                        </div>

                        <div>
                          <strong>Motivat de:</strong>&nbsp;
                          {motivare.autorMotivare}
                        </div>
                      </div>

                      <div style={{ textAlign: "center", marginTop: "10px" }}>
                        <strong>Motiv motivare:</strong>
                      </div>

                      <TextArea
                        value={motivare.motivMotivare || "Fără motiv specificat"}
                        style={{
                          width: "80%",
                          outline: "none",
                          display: "block",
                          margin: "10px auto"
                        }}
                        disabled
                      />

                      {/* Buton pentru anularea motivării */}
                      {modeOf !== "view" && user.type === "admin" && (
                        <div style={{ textAlign: "center", marginTop: "15px" }}>
                          <Button
                            danger
                            onClick={async () => {
                              if (!window.confirm("Sigur vrei să anulezi această motivare manuală?")) {
                                return;
                              }

                              try {
                                const { note } = await getDataDoc("catalog", elevId);

                                // Găsește absența și anulează motivarea
                                await updateDocDatabase("catalog", elevId, {
                                  note: (note || []).map((n) =>
                                    n.id === motivare.id
                                      ? {
                                          ...n,
                                          motivat: false,
                                          motivareManual: false,
                                          motivMotivare: null,
                                          dataMotivare: null,
                                          autorMotivare: null
                                        }
                                      : n
                                  ),
                                });

                                // Șterge din colecția de motivări manuale
                                try {
                                  await deleteDataDoc("motivari-manuale", motivare.id);
                                } catch (err) {
                                  // Ignoră eroarea dacă documentul nu există
                                }

                                // Înregistrează în changelog
                                let now = new Date();
                                let onejan = new Date(now.getFullYear(), 0, 1);
                                let week = Math.ceil(
                                  ((now.getTime() - onejan.getTime()) / 86400000 +
                                    onejan.getDay() +
                                    1) /
                                    7
                                );

                                let changelogGet = await getDataDoc(
                                  "changelog",
                                  classId + "week" + week
                                );
                                let previous = [];
                                if (changelogGet) previous = changelogGet;

                                await updateDocDatabase(
                                  "changelog",
                                  classId + "week" + week,
                                  {
                                    changelog: [
                                      ...(previous.changelog || []),
                                      {
                                        author: user.displayName,
                                        time: Date.now(),
                                        classId,
                                        elevId,
                                        action: "anulare_motivare_manuala",
                                        motivare: {
                                          id: motivare.id,
                                          data: motivare.date,
                                          materie: materieNume,
                                          motivAnulat: motivare.motivMotivare
                                        }
                                      },
                                    ],
                                  }
                                );

                                openSuccesNotification("Motivarea manuală a fost anulată");
                              } catch (error) {
                                console.error("Eroare la anularea motivării:", error);
                                openErrorNotification("A apărut o eroare la anularea motivării");
                              }
                            }}
                          >
                            Anulează Motivarea
                          </Button>
                        </div>
                      )}
                    </Accordion.Content>
                  </div>
                );
              })}
          </Accordion>
        </>
      )}

      {transferuri === true && elevData?.transferuri?.length > 0 && (
        <>
          <h3 style={{ textAlign: "center" }}>Transferuri</h3>
          {elevData?.transferuri?.map((t) => {
            return (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                  }}
                >
                  <div>
                    Clasa Veche:{" "}
                    {renderClassName(clase?.find((c) => c.id === t.clasaVeche))}
                  </div>
                  <div>
                    Clasa Noua:{" "}
                    {renderClassName(clase?.find((c) => c.id === t.clasaNoua))}
                  </div>

                  <div>Din data de: {formatDate(new Date(t.dataTransfer))}</div>
                </div>
                <br />
                <TextArea
                  value={t.details}
                  style={{ width: "50%", outline: "none" }}
                />
                <br />
                <br />
                <br />
                {modeOf !== "view" && (
                  <>
                    <Button
                      onClick={() => {
                        setPromiss(t.clasaNoua);
                        setClasaVeche(t.clasaVeche);
                        setIdTransfer(t.id);
                        setEditTransfer(true);
                      }}
                    >
                      Modifica transfer
                    </Button>
                    <Button
                      style={{ marginLeft: "10px" }}
                      danger
                      onClick={async () => {
                        let transferuri = elevData.transferuri.filter(
                          (a) => a.id !== t.id
                        );

                        await updateDocDatabase("elevi", elevData.id, {
                          transferuri: transferuri,
                        });
                        window.location.reload();
                      }}
                    >
                      Sterge Transfer
                    </Button>
                  </>
                )}
                <br /> <br />
                <br />
              </>
            );
          })}
        </>
      )}

      <br />
      <br />
    </div>
  );
};
export default withErrorBoundary(Docs);
